export default __webpack_public_path__ + "static/media/excel.bbc1130c.svg";